var _path, _path2, _path3, _path4, _path5, _g, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlkimaErfolgsgeschichteBwOnlineShopLaptopMockup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1011,
    height: 548,
    viewBox: "0 0 1011 548",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M505.898 528.1H0.898438V533.6H505.898V528.1Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1010.9 528.1H505.898V533.6H1010.9V528.1Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.5 514.7C102.5 526.7 112.3 536.5 124.3 536.5V536.6H887.4C899.4 536.6 909.2 526.8 909.2 514.8V21.8999C909.2 9.8999 899.4 0.0998535 887.4 0.0998535H124.3C112.3 0.0998535 102.5 9.8999 102.5 21.8999V514.7ZM246.4 26.2H489.6H890.3V93.4999V414.2V506.7H847.1H489.8H371.8H283.8H121.5V123.2V26.2H152.7H246.4Z",
    fill: "#D2CCC9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104 21.8999V514.8C104 526 113.1 535.1 124.3 535.1H887.4C898.6 535.1 907.7 526 907.7 514.8V21.8999C907.7 10.6999 898.6 1.59985 887.4 1.59985H124.3C113.1 1.59985 104 10.6999 104 21.8999ZM246.4 26.2H489.6H890.3V93.4999V414.2V506.7H847.1H489.8H371.8H283.8H121.5V123.2V26.2H152.7H246.4Z",
    fill: "#131313"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M939.198 547.5H72.4984C51.6984 547.5 30.8984 544 10.8984 537.1L0.898438 533.6H1010.9L1000.9 537.1C980.798 544 960.098 547.5 939.198 547.5Z",
    fill: "url(#paint2_linear)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.79
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M500.898 14.4999C500.898 11.7999 503.098 9.59985 505.798 9.59985C508.498 9.59985 510.698 11.7999 510.698 14.4999C510.698 17.1999 508.498 19.3999 505.798 19.3999C503.098 19.3999 500.898 17.1999 500.898 14.4999Z",
    fill: "url(#paint3_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M509.698 14.4999C509.698 16.5999 507.098 18.1999 506.398 17.7999C505.998 17.5999 506.398 16.7999 506.398 14.4999C506.398 12.1999 505.998 11.3999 506.398 11.1999C507.098 10.7999 509.698 12.3999 509.698 14.4999Z",
    fill: "url(#paint4_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M502.198 14.4999C502.198 15.9999 503.898 17.0999 504.298 16.7999C504.498 16.5999 504.298 16.0999 504.298 14.4999C504.298 12.8999 504.498 12.2999 504.298 12.1999C503.798 11.8999 502.198 12.9999 502.198 14.4999Z",
    fill: "url(#paint5_linear)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M578.998 528.1C578.298 528.7 577.398 529.3 576.298 529.8C573.598 531.1 569.998 531.8 565.898 531.8H445.798C440.098 531.8 435.198 530.3 432.698 528H578.998V528.1Z",
    fill: "url(#paint6_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 0.849237,
    y1: 530.866,
    x2: 505.861,
    y2: 530.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00231783,
    stopColor: "#343434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00588773,
    stopColor: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0091096,
    stopColor: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0118657,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0140476,
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0153846,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0204295,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0326428,
    stopColor: "#838383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0426664,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0499897,
    stopColor: "#212121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0538462,
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0595758,
    stopColor: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.066081,
    stopColor: "#646362"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0732521,
    stopColor: "#868584"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0810361,
    stopColor: "#A4A2A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0896354,
    stopColor: "#BBBAB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0993859,
    stopColor: "#CECCC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.111,
    stopColor: "#DAD9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1262,
    stopColor: "#E2E0DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#E4E2DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4282,
    stopColor: "#ADB9C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6641,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 505.861,
    y1: 530.866,
    x2: 1010.87,
    y2: 530.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3359,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5718,
    stopColor: "#ADB9C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.841,
    stopColor: "#E4E2DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8738,
    stopColor: "#E2E0DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.889,
    stopColor: "#DAD9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9006,
    stopColor: "#CECCC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9104,
    stopColor: "#BBBAB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.919,
    stopColor: "#A4A2A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9267,
    stopColor: "#868584"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9339,
    stopColor: "#646362"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9404,
    stopColor: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9462,
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#212121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9573,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9674,
    stopColor: "#838383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9796,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9846,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.986,
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9881,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9909,
    stopColor: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9941,
    stopColor: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9977,
    stopColor: "#343434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#030303"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 505.861,
    y1: 546.608,
    x2: 505.861,
    y2: 526.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1B1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8BFC4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(505.861 14.5183) scale(4.93669)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9872
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(508.726 13.8478) scale(5.39998)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2936,
    stopColor: "#575376"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5886,
    stopColor: "#342C6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8251,
    stopColor: "#1F1568"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9718,
    stopColor: "#170C66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 504.371,
    y1: 14.5183,
    x2: 502.158,
    y2: 14.5183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9718,
    stopColor: "#292D95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 432.724,
    y1: 530,
    x2: 578.998,
    y2: 530,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00418205,
    stopColor: "#0B0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0267168,
    stopColor: "#313131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0502133,
    stopColor: "#505050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0746006,
    stopColor: "#686868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1002,
    stopColor: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128,
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1615,
    stopColor: "#878787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8231,
    stopColor: "#878787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8534,
    stopColor: "#838383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8843,
    stopColor: "#777777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9155,
    stopColor: "#626262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9469,
    stopColor: "#464646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9782,
    stopColor: "#212121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#030303"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlkimaErfolgsgeschichteBwOnlineShopLaptopMockup);
export default __webpack_public_path__ + "static/media/alkima-erfolgsgeschichte-bw-online-shop-laptop-mockup.7565813263ae42b2ff81413380798036.svg";
export { ForwardRef as ReactComponent };